var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container view-container" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(_vm._s(_vm.$t("SettingIndexesList.details.title")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.tryCancel } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submit("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("saveText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "200px" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SettingIndexesList.indexCode"),
                        prop: "indexCode",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: "",
                        },
                        model: {
                          value: _vm.form.indexCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "indexCode", $$v)
                          },
                          expression: "form.indexCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SettingIndexesList.remark"),
                        prop: "remark",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: "",
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.statusText"),
                        prop: "enabledFlag",
                      },
                    },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.enabledFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "enabledFlag", $$v)
                          },
                          expression: "form.enabledFlag",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SettingIndexesList.details.shards"),
                        prop: "shards",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: "",
                        },
                        model: {
                          value: _vm.form.shards,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "shards", $$v)
                          },
                          expression: "form.shards",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SettingIndexesList.details.replicas"),
                        prop: "replicas",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: "",
                        },
                        model: {
                          value: _vm.form.replicas,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "replicas", $$v)
                          },
                          expression: "form.replicas",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.createdByText") } },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: "",
                          disabled: true,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SettingIndexesList.updateUser") },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: "",
                          disabled: true,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SettingIndexesList.lastUpdateDate"),
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: "",
                          disabled: true,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.createTimeText") } },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: "",
                          disabled: true,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "BjDivider",
        [
          _vm._v(_vm._s(_vm.$t("SettingIndexesList.details.syncField")) + " "),
          _c(
            "template",
            { slot: "button" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                [_vm._v(_vm._s(_vm.$t("addText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-table",
        { attrs: { border: "", data: _vm.form.indexFieldList } },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("SettingIndexesList.details.fieldName"),
              align: "center",
              prop: "fieldName",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("inputText"),
                      },
                      model: {
                        value: scope.row.fieldName,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "fieldName", $$v)
                        },
                        expression: "scope.row.fieldName",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("SettingIndexesList.details.fieldType"),
              align: "center",
              prop: "fieldType",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("inputText"),
                      },
                      on: {
                        blur: function ($event) {
                          return _vm.checkType(scope.$index)
                        },
                      },
                      model: {
                        value: scope.row.fieldType,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "fieldType", $$v)
                        },
                        expression: "scope.row.fieldType",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("SettingIndexesList.details.analyzerFlag"),
              align: "center",
              prop: "analyzerFlag",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          disabled: scope.row.fieldType !== "Text",
                          placeholder: _vm.$t("chooseText"),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.selection(scope.$index)
                          },
                        },
                        model: {
                          value: scope.row.analyzerFlag,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "analyzerFlag", $$v)
                          },
                          expression: "scope.row.analyzerFlag",
                        },
                      },
                      _vm._l(_vm.STATUS_YES_NUM, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: {
                            label: _vm.$t(item.label),
                            value: item.value,
                          },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("SettingIndexesList.details.filedAnalyzerCode"),
              align: "center",
              prop: "filedAnalyzerCode",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        disabled: scope.row.analyzerFlag !== 1,
                        placeholder: _vm.$t("inputText"),
                      },
                      model: {
                        value: scope.row.filedAnalyzerCode,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "filedAnalyzerCode", $$v)
                        },
                        expression: "scope.row.filedAnalyzerCode",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("SettingIndexesList.details.pkFlag"),
              align: "center",
              prop: "pkFlag",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: _vm.$t("chooseText") },
                        model: {
                          value: scope.row.pkFlag,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "pkFlag", $$v)
                          },
                          expression: "scope.row.pkFlag",
                        },
                      },
                      _vm._l(_vm.STATUS_YES_NUM, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: {
                            label: _vm.$t(item.label),
                            value: item.value,
                          },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("table.operationText"), align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.onDelete(scope.$index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("delText")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt20", staticStyle: { "text-align": "right" } },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pageNun,
              "page-sizes": _vm.PAGE_SIZES,
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }